import * as YXXGameProto from "./proto/yxx_proto_game";
import * as YXXRoomProto from "./proto/yxx_proto_room";
const { ccclass, property } = cc._decorator;

@ccclass
export default class NetMessageDataLongHuDouGame {
    //发送命令名|发送结构体|收包命令|收包结构体|协议类型:1为登录服，2为麻将游戏服，3为Skynet扑克服
    //离开房间
    static LeaveRoom: any[] = ["Room.LeaveReq", YXXRoomProto.YXXRoom.LeaveReq, "Room.LeaveRsp", YXXRoomProto.YXXRoom.LeaveRsp, 3]
    //房间信息
    static RoomInfo: any[] = [null, null, "Room.RoomInfo", YXXRoomProto.YXXRoom.RoomInfo, 3]

    //彩池余额
    static JackpotChange: any[] = [null, null, "Room.JackpotChange", YXXRoomProto.YXXRoom.JackpotChange, 3]
    //彩池新增
    static JackpotAdd:any[] = [null, null, "Room.JackpotAdd", YXXRoomProto.YXXRoom.JackpotAdd, 3]

    //押注请求以及返回
    static BetReq: any[] = ["Game.BetReq", YXXGameProto.YXXGame.BetReq, "Game.BetRsp", YXXGameProto.YXXGame.BetRsp, 3]
    //押注数据
    static BetData: any[] = [null, null, "Game.BetBroadCast", YXXGameProto.YXXGame.BetBroadCast, 3]
    //获取结果
    static BetResult: any[] = [null, null, "Game.BetResult", YXXGameProto.YXXGame.BetResult, 3]
    //最近结果
    static TwentyTimesResult: any[] = [null, null, "Game.BetResultHistory", YXXGameProto.YXXGame.BetResultHistory, 3]
    //获取历史数据(最多15*7局)
    static GetHistoryResult: any[] = ["Game.BetResultDetailReq", YXXGameProto.YXXGame.BetResultDetailReq, "Game.BetResultDetailRsp", YXXGameProto.YXXGame.BetResultDetailRsp, 3]
    //获取在线玩家
    static GetOnlinePlayers: any[] = ["Game.OnlinePlayersReq", YXXGameProto.YXXGame.OnlinePlayersReq, "Game.OnlinePlayersRsp", YXXGameProto.YXXGame.OnlinePlayersRsp, 3]
    //上下庄请求
    static BankerReq: any[] = ["Game.BankerReq", YXXGameProto.YXXGame.BankerReq, "Game.BankerRsp", YXXGameProto.YXXGame.BankerRsp, 3]
    //庄家信息
    static BankerInfo: any[] = [null, null, "Game.BankerInfo", YXXGameProto.YXXGame.BankerInfo, 3]
    //等待上庄的玩家
    static WaitBankerList: any[] = [null, null, "Game.BankerList", YXXGameProto.YXXGame.BankerList, 3]
    //消息通知
    static NotifyMsg: any[] = [null, null, "Game.NotifyMsg", YXXRoomProto.YXXRoom.NotifyMsg, 3]

     //彩池数据
     static JackpotResult: any[] = ["Room.GetJackpotResult", YXXRoomProto.YXXRoom.GetJackpotResult, "Room.JackpotResult", YXXRoomProto.YXXRoom.JackpotResult, 3]
}